import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { ModelCombobox } from '../ModelCombobox';
import { opportunitiesAPI } from '../../lib/api';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export const MissingModelsDialog = ({ open, onOpenChange, opportunities, getClientName, onSaved }) => {
    const [values, setValues] = useState({});
    const [saving, setSaving] = useState(false);

    const changed = Object.entries(values).filter(([, v]) => v);

    const handleSave = async () => {
        if (!changed.length) { onOpenChange(false); return; }
        setSaving(true);
        let ok = 0;
        for (const [id, modello] of changed) {
            try {
                await opportunitiesAPI.update(id, { modello });
                ok += 1;
            } catch (e) {
                toast.error(`Errore nel salvataggio di una commessa`);
            }
        }
        setSaving(false);
        if (ok) toast.success(`${ok} commesse aggiornate`);
        setValues({});
        onSaved?.();
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={(v) => { if (!saving) { onOpenChange(v); if (!v) setValues({}); } }}>
            <DialogContent className="max-w-3xl" data-testid="missing-models-dialog">
                <DialogHeader>
                    <DialogTitle className="font-heading uppercase">Compila modelli mancanti</DialogTitle>
                </DialogHeader>
                <p className="text-sm text-muted-foreground">
                    {opportunities.length} commesse senza modello. Seleziona il modello per quelle che conosci e premi Salva.
                </p>
                <div className="max-h-[60vh] overflow-y-auto divide-y border rounded-sm">
                    {opportunities.map(o => (
                        <div key={o.id} className="grid grid-cols-1 md:grid-cols-2 gap-2 p-3 items-center" data-testid={`missing-model-row-${o.id}`}>
                            <div className="min-w-0">
                                <div className="font-medium text-sm truncate">{o.title}</div>
                                <div className="text-xs text-muted-foreground truncate">
                                    {getClientName(o.client_id)}
                                    {o.commessa ? ` · Comm. ${o.commessa}` : ''}
                                    {o.telaio ? ` · ${o.telaio}` : ''}
                                </div>
                            </div>
                            <ModelCombobox
                                value={values[o.id] || ''}
                                onChange={(m) => setValues(v => ({ ...v, [o.id]: m }))}
                                testid={`missing-model-select-${o.id}`}
                            />
                        </div>
                    ))}
                </div>
                <div className="flex justify-end gap-2">
                    <Button variant="outline" onClick={() => onOpenChange(false)} disabled={saving} data-testid="missing-models-cancel">Annulla</Button>
                    <Button className="btn-primary" onClick={handleSave} disabled={saving || !changed.length} data-testid="missing-models-save">
                        {saving && <Loader2 size={14} className="mr-2 animate-spin" />}
                        Salva {changed.length ? `(${changed.length})` : ''}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default MissingModelsDialog;
